module.exports = __webpack_public_path__ + "static/media/foot-icon-college.9623e029.jpg";